import { GoogleplaceDirective } from './../../plugins/googleaddressautocomplete/google-address-autocomplete';
import { IKeyValueInterface, Marker, RoleLevel } from './../../shared/config';
import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { OrganizationModel, OrganizationAddressModel } from '../models/organization.model';
import { OrganizationService } from '../models/organization.service';
import { PersonModel } from '../../person/models/person.model';
import { PersonService } from '../../person/models/person.service';
import { InstanceService } from '../../instance/models/instance.service';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, PermissionType } from '../../shared/config';
import { Location } from '@angular/common';
import { CompanyService } from "../../company/models/company.service";
import { CompanyModel } from "../../company/models/company.model";
import { DropdownModel } from '../../report/models/report-filter.model';
import { FlatPickrDirective } from "./../../plugins/flatpickr/flatpickr.directive";
import { FlatPickrModel } from "./../../plugins/flatpickr/flatpickr.model";
import { GdprSettingsModel } from '../../instance/models/instance.model';

@Component({
  selector: 'wego-organization',
  template: require('../views/organization-update.component.html'),
  providers: [OrganizationService, PersonService, InstanceService, CompanyService, GoogleplaceDirective],
})
export class OrganizationUpdateComponent implements OnInit, OnDestroy {
  timeIntervalList: { Key: string; Value: string; Amount: number; }[];
  public totalItems: number = 0;
  public currentPage: number = 1;
  public maxSize: number = WeGoConfig.GRID_MAX_PAGE_SIZE;
  public itemsPerPage: number = WeGoConfig.GRID_MAX_DATA_SIZE;
  private organizationMasterHashId: string;
  private sub: any;
  model: OrganizationModel;
  apiResponse: IAPIResponse;
  personList: PersonModel[];
  errorModel: IKeyValueInterface[];
  companyList: DropdownModel[];
  errorMessage: string;
  message: string;
  instanceList: DropdownModel[];
  isEditMode: boolean;
  preferredlanguage: any;
  debtornr: string;
  vatnr: string;
  companymasterHashId: string;
  pageName: string;
  accessDeniedErrorCode: string;
  flatPickrConfigFrom: FlatPickrModel;
  dayofWeekList: any;
  gdprSettingsModel: GdprSettingsModel = new GdprSettingsModel();

  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;

  public searchField: string = "";
  public searchTerm: string = "";
  public selectedInstance: string = "";
  public language: string = 'en';

  urlDefaultPage: string;
  urlOrganizationList: string;
  roleLevel = RoleLevel;

  markerInfo: Marker;

  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('TwoFasuccessPopup') public TwoFasuccessPopup: any;
  
  @ViewChild('googleMapComp') public googleMapComp: any;
  @ViewChild('geoLocationModal') public geoLocationModal: any;
  @ViewChild("flatPickrConfigFromDate")
  public flatPickrConfigFromDate: FlatPickrDirective;
  TwoFaEnabled: any;
  popupTitle: string;

  constructor(private organizationService: OrganizationService,
    private personService: PersonService,
    private instanceService: InstanceService,
    private companyService: CompanyService,
    private translate: TranslateService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private locationService: Location) {
  }

  ngOnInit() {
    this.accessDeniedErrorCode = "412";
    this.pageName = "Organization";
    this.module = this.translate.instant('LblOrganization');
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlOrganizationList = this.authService.GetURL(ApplicationRouteURL.URL_ORGANIZATION_LIST);
    this.companyList = [];
    this.isEditMode = false;


    this.preferredlanguage = [
      {
        Key: "English",
        Value: "en_US"
      },
      {
        Key: "French",
        Value: "fr_FR"
      },
      {
        Key: "Dutch",
        Value: "nl_NL"
      },
      {
        Key: "German",
        Value: "de_DE"
      },
      {
        Key: "Polish",
        Value: "pl_PL"
      },
      {
        Key: "Spanish",
        Value: "es_ES"
      }
    ];

    this.dayofWeekList = [
      {
        Key: this.translate.instant('LblSelectDayOfWeek'),
        Value: ''
      },
      {
        Key: this.translate.instant('LblSunday'),
        Value: '0'
      },
      {
        Key: this.translate.instant('LblMonday'),
        Value: '1'
      },
      {
        Key: this.translate.instant('LblTuesday'),
        Value: '2'
      },
      {
        Key: this.translate.instant('LblWednesday'),
        Value: '3'
      },
      {
        Key: this.translate.instant('LblThursday'),
        Value: '4'
      },
      {
        Key: this.translate.instant('LblFriday'),
        Value: '5'
      },
      {
        Key: this.translate.instant('LblSaturday'),
        Value: '6'
      }];

    this.timeIntervalList = [
      {
        Key: this.translate.instant('LblSelectInvoiceInterval'),
        Value: '',
        Amount: 0
      },
      {
        Key: this.translate.instant('LblWeeklySub'),
        Value: 'WEEKLY',
        Amount: 7,
      },
      {
        Key: this.translate.instant('LblMonthlySub'),
        Value: 'MONTHLY',
        Amount: 30
      },
      {
        Key: this.translate.instant('LblYearlySub'),
        Value: 'YEARLY',
        Amount: 365
      }
    ];

    this.model = new OrganizationModel();
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.GetOrganizationDetails();
  }

  private SetDefaultFlatPickrConfig(isDateOnly?: boolean) {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = !isDateOnly ? true : false;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    flatPickrConfig.maxDate = new Date();
    return flatPickrConfig;
  }


  public GetOrganizationDetails() {
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.organizationMasterHashId = params['id'] || '';
        if (this.organizationMasterHashId != '') {
          this.isEditMode = true;
          this.organizationService.GetOrganizationByHashId(this.organizationMasterHashId)
            .subscribe(
              res => {
                this.model = res.data;
                this.model.invoiceMomentDayOfWeek = res.data.invoiceMomentDayOfWeek;
                this.language = res.data.instanceLanguage;
                if (this.model.displayorganizationGeoLocationAddress) {
                  this.markerInfo = {
                    draggable: false,
                    lat: this.model.organizationGeoLocationLatitude,
                    lng: this.model.organizationGeoLocationLongitude,
                    label: this.model.displayorganizationGeoLocationAddress,
                    isOpen: true
                  };
                }
                this.onChangeSelectedField(this.model.companyMasterHashId);
                this.GetGDPRSettings();
              },
              error => {
                this.errorMessage = this.authService.HandleErrorStatusCode(error);
              });
        }
        else {
          this.model.preferredlanguage =
            this.preferredlanguage.length > 0
              ? this.preferredlanguage[0].Value
              : "";
          this.GetInstanceDropDownList(PermissionType.INSERT);
        }
      });
    this.breadCrumbTitle = this.isEditMode ? this.translate.instant('LblEditPage', [this.module]) : this.translate.instant('LblAddPage', [this.module]);
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
  }

  onSubmit(forms: any) {
    console.log(this.model);
    this.AddOrganization();
  }

  public AddOrganization() {
    this.organizationService.AddOrganization(this.model)
      .subscribe(
        res => {
          if (res.data) {
            this.popupTitle = this.translate.instant('LblSuccess');
            this.popupMsg = this.isEditMode ? this.translate.instant('LblRecordUpdatedSuccess', [this.module]) : this.translate.instant('LblRecordAddedSuccess', [this.module]);
            this.ShowSuccessPopup();
          }
          else {
            this.errorModel = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        });
  }

  public GetInstanceDropDownList(permissionType: string) {
    this.instanceService.GetInstanceListDropdownForAddUpdatePage(this.pageName, permissionType)
      .subscribe(
        res => {
          this.apiResponse = res;
          this.instanceList = res.data;
          this.model.companyMasterHashId = '';

          if (this.instanceList && this.instanceList.length > 0) {
            if (!this.model.instanceHashId && this.instanceList.length == 1) {
              this.model.instanceHashId = this.instanceList[0].keyHash;
            }
            this.InstanceUpdate();
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        },
      );
  }

  public GetGDPRSettings() {
    this.organizationService.GetOrganizationGDPRSettings(this.organizationMasterHashId)
      .subscribe(
        res => {
          if (res.data) {
            this.gdprSettingsModel = res.data;
          } else {
            this.errorMessage = res.error;
          }

        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        },
      );
  }

  public GetCompanyDropDownList(permissionType: string) {
    this.companyService.GetCompanyListDropdownForAddUpdatePage(this.pageName, permissionType, this.model.instanceHashId)
      .subscribe(
        res => {
          this.companyList = res.data;
          this.model.companyMasterHashId = this.model.companyMasterHashId || this.companyList.length > 0 ? '' : '';

          if (this.companyList && this.companyList.length > 0) {
            if (!this.model.companyMasterHashId && this.companyList.length == 1) {
              this.model.companyMasterHashId = this.companyList[0].keyHash;
            }
          }
        },
        error => {
          this.errorMessage = <any>error;
        },
      );
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public GetGeoLocation(event: any) {
    if (this.model) {
      let locationData = event.GeoLocationData;
      this.model.orgnizationGeoLocationAddress = locationData.label;
      this.model.organizationGeoLocationLatitude = locationData.lat;
      this.model.organizationGeoLocationLongitude = locationData.lng;
    }
  }

  public InstanceUpdate() {
    if (this.model.instanceHashId) {
      this.GetCompanyDropDownList(PermissionType.INSERT);

      this.instanceService
        .GetInstanceLanguage(this.model.instanceHashId)
        .subscribe(
          res => {
            this.language = res.data;
          },
          error => {
            this.errorMessage = this.authService.HandleErrorStatusCode(error);
          }
        );

      this.instanceService
        .IsDirectDebitEnabled(this.model.instanceHashId)
        .subscribe(
          res => {
            this.apiResponse = res;
            let directDebitEnabled: boolean = res.data;
            if (directDebitEnabled) {
              this.model.directDebitBillingInfoModel.directDebitFileEnabledOnInstance = true;
              this.model.directDebitBillingInfoModel.subjectToDirectDebit = true;
            } else {
              this.model.directDebitBillingInfoModel.directDebitFileEnabledOnInstance = false;
              this.model.directDebitBillingInfoModel.subjectToDirectDebit = false;
            }
          },
          error => {
            this.errorMessage = this.authService.HandleErrorStatusCode(error);
          }
        );
    }
    else {
      this.companyList = [];
      this.model.companyMasterHashId = "";
    }
  }


  public OnBackClick() {
    this.locationService.back();
  }
  public GetAddress(place: Object) {

    this.model.displayorganizationGeoLocationAddress = place['address'];

    this.model.organizationGeoLocationLatitude = place['lat'];

    this.model.organizationGeoLocationLongitude = place['log'];

    this.model.orgnizationGeoLocationAddress = place['useraddressInput'];
  }

  public SearchHomeAddress() {
    this.geoLocationModal.show(this.model.displayorganizationGeoLocationAddress, this.model.organizationGeoLocationLatitude, this.model.organizationGeoLocationLongitude);
  }

  public ResetLocationField(locationModelField: string) {
    this.model.displayorganizationGeoLocationAddress = '';
    this.model.organizationGeoLocationLatitude = 0;
    this.model.organizationGeoLocationLongitude = 0;
  }

  public onConfirm($event: any) {
    this.model.displayorganizationGeoLocationAddress = $event.address;
    this.model.organizationGeoLocationLatitude = $event.lat;
    this.model.organizationGeoLocationLongitude = $event.long;
  }

  public ResetCookies() {
    this.organizationService.ResetTwoFaCookies(this.organizationMasterHashId)
      .subscribe(
        (res: any) => {
          if (res.data) {
            this.popupTitle = this.translate.instant('LblSuccess');
            this.popupMsg = this.translate.instant('LblCookieResetSuccess', [this.module]);
            this.ShowTwoFaPopup();
          }
          else {
            this.popupMsg = this.translate.instant('LblCookieResetFailed');
            this.popupTitle = this.translate.instant('LblError');
            this.ShowTwoFaPopup();
          }
        },
        (error: any) => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);

        });
  }

  public ResetTwoFA() {
    this.organizationService.ResetTwoFaKeys(this.organizationMasterHashId)
      .subscribe(
        (res: any) => {
          if (res.data) {
            this.popupTitle = this.translate.instant('LblSuccess');
            this.popupMsg = this.translate.instant('LblKeyResetSuccess', [this.module]);
            this.ShowTwoFaPopup();
          }
          else {
            this.popupMsg = this.translate.instant('LblKeyResetFailed');
            this.popupTitle = this.translate.instant('LblError');
            this.ShowTwoFaPopup();
          }
        },
        (error: any) => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);

        });
  }

  
  public ShowTwoFaPopup(): void {
    this.TwoFasuccessPopup.show();
  }

  public ConfirmTwoFaPopup(): void {
    this.TwoFasuccessPopup.hide();
  }

  public onChangeSelectedField(selectedCompany: any) {
    if (selectedCompany) {
      this.companyService
        .IsTwoFaEnabled(selectedCompany)
        .subscribe(
          res => {
            this.TwoFaEnabled = res.data;
          },
          error => {
            this.errorMessage = this.authService.HandleErrorStatusCode(error);
          }
        );
    } else {
      this.TwoFaEnabled = false;
    }
  }


  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organization/components/organization-update.component.ts